import { belongsTo } from '@ember-data/model';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
export default ItemsV3Base.extend({
  surcharge: belongsTo('surcharge', {
    async: false
  }),
  fee: belongsTo('fee', {
    async: false
  })
}).reopenClass({
  catalogType() {
    return 'SURCHARGE_FEE_MEMBERSHIP';
  },
  _modelNameForMigration: 'surcharge-fee-membership'
});